import React from "react";
import { Typography } from "@material-ui/core";

const UsageHelpText = () => {
  return (
    <div>
      <Typography variant="body2">
        You can export usage reports by specifying start and end dates. If you
        use Creator, you have two report options; Subscribed Module Report or Creator Content
        Report.
      </Typography>
      <Typography variant="body2">
        First, choose the organization you'd like usage for, then pick what type
        of report you'd like to export.
      </Typography>
      <ul>
        <li>
          <strong>Subscribed Modules Report:</strong> This report provides usage
            for Modules your organization is subscribed to.  Excludes anthology
            names, unless you check the "Include Anthologies" check box to add
            the name to your report. You can export single modules or request a
            report with all the modules in your organization.
        </li>
        <li>
          <strong>Creator Content Report:</strong> This report provides usage for
            Content organized in Creator.  If you share your content with Open Access,
            usage will be included for all libraries that have access to the content.
            *Note: If you don't use Creator and try to export a "Creator Content Report",
            the .csv file that downloads will be empty.
        </li>
      </ul>
      <Typography variant="body2">
        Once exported the report will include the following terms under the Code
        or Description column:
      </Typography>
      <ul>
        <li>
          <strong>Result Click:</strong> A patron clicked on a search result.
        </li>
        <li>
          <strong>Record View:</strong> A patron opened a content detail page.
        </li>
        <li>
          <strong>Successful Title Request:</strong> A patron opened a book.
        </li>
        <li>
          <strong>Successful Multimedia Full Content Request:</strong> A patron
          opened an image, audio, or video file.
        </li>
      </ul>
      <Typography variant="body2">
        <strong>NOTE:</strong> The report could take some time to generate,
        depending on the date range you use.
      </Typography>
    </div>
  );
};

export default UsageHelpText;
